<template>
  <div class="container py-4">
    <div class="card shadow-lg">
      <div class="card-header bg-primary text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
        <h5 class="mb-2 mb-md-0">🎨 Theme Settings</h5>
        <span class="badge bg-light text-dark">{{ modeLabel }}</span>
      </div>
      <div class="card-body">
        <p class="text-muted mb-3">Click a theme to apply it:</p>
        <div class="d-flex flex-wrap justify-content-center">
          <label
            v-for="mode in modes"
            :key="mode.value"
            class="btn m-1"
            :class="[currentMode === mode.value ? mode.activeClass : mode.defaultClass]"
          >
            <input
              type="radio"
              name="theme"
              :value="mode.value"
              v-model="currentMode"
              @change="onThemeChange"
              autocomplete="off"
            />
            {{ mode.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import axios from 'axios';

export default {
  data() {
    return {
      currentMode: 'light-mode',
      userId: localStorage.getItem('id'),
      token: localStorage.getItem('token'),
      modes: [
        {
          label: 'Light',
          value: 'light-mode',
          defaultClass: 'btn-outline-secondary',
          activeClass: 'btn-secondary text-white'
        },
        {
          label: 'Dark',
          value: 'dark-mode',
          defaultClass: 'btn-outline-dark',
          activeClass: 'btn-dark text-white'
        },
        {
          label: 'Light Gold',
          value: 'custom-mode',
          defaultClass: 'btn-outline-warning',
          activeClass: 'btn-warning text-dark'
        },
        {
          label: 'Blue',
          value: 'blue-mode',
          defaultClass: 'btn-outline-primary',
          activeClass: 'btn-primary text-white'
        },
        {
          label: 'Green',
          value: 'green-mode',
          defaultClass: 'btn-outline-success',
          activeClass: 'btn-success text-white'
        },
        {
          label: 'Pink',
          value: 'pink-mode',
          defaultClass: 'btn-outline-pink',
          activeClass: 'btn-pink text-white'
        }
      ]
    };
  },
  computed: {
    modeLabel() {
      return this.currentMode.replace('-mode', '').toUpperCase();
    }
  },
  async mounted() {
    await this.fetchThemeFromDatabase();
    this.applyModeClass(this.currentMode);
  },
  methods: {
    async onThemeChange() {
      localStorage.setItem('themeMode', this.currentMode);
      this.applyModeClass(this.currentMode);
      await this.saveThemeToDatabase();
    },
    applyModeClass(mode) {
      const allModes = this.modes.map(m => m.value);
      document.body.classList.remove(...allModes);
      document.body.classList.add(mode);
    },
    async fetchThemeFromDatabase() {
      try {
        const response = await axios.get(`/getThemeColorSettings/${this.userId}`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });
        if (response.data?.theme_color) {
          this.currentMode = response.data.theme_color;
          localStorage.setItem('themeMode', this.currentMode);
        }
      } catch (error) {
        console.error('Failed to fetch theme:', error);
      }
    },
    async saveThemeToDatabase() {
      try {
        await axios.post('/saveThemeColorSettings', {
          user_id: this.userId,
          theme_color: this.currentMode
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        });
        console.log('Theme saved to DB');
      } catch (error) {
        console.error('Failed to save theme:', error);
      }
    }
  }
};
</script>



<style scoped lang="scss">
.container{
    margin-top: 5%;
    position: absolute;
    z-index: 0;
    
}
.btn-pink {
  background-color: #e83e8c;
  border-color: #e83e8c;
}
.btn-outline-pink {
  color: #e83e8c;
  border-color: #e83e8c;
}
.btn-outline-pink:hover {
  background-color: #e83e8c;
  color: #fff;
}

/* Responsive padding for card */
.card {
  padding: 1rem;
}

@media (max-width: 576px) {

    .container{
        max-width: 350px;
    }
  .card-header h5 {
    font-size: 1rem;
  }

  .badge {
    font-size: 0.8rem;
  }

  .btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.6rem;
  }
}
</style>

